// eslint-disable-next-line import/prefer-default-export
export const ORDERS_URL = '/app/orders'
export const LP_ONBOARDING_URL = `${ORDERS_URL}/lp-onboarding`

export const PHONE_PATTERN =
  /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$|\d{10}$/

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
